import React, { FC } from 'react';

import { Box, Stack, Text } from '@chakra-ui/react';

import { CustomTooltip } from 'components/DataDisplay';
import { ReferenceWrapper } from 'containers/ConversationalAI/Components/AiAssistant/References/ReferenceWrapper';
import { renderDomain } from 'containers/ConversationalAI/Components/AiAssistant/References/utils';

interface AIReferenceProps {
  url: string;
  title: string;
}

export const AIReferenceCard: FC<AIReferenceProps> = props => {
  const { url, title } = props;

  return (
    <Box >
      <CustomTooltip
        bg="white"
        label={
          <Stack>
            {renderDomain(url)}
            <Box color="black">{title}</Box>
          </Stack>
        }
      >
        <ReferenceWrapper onClick={() => window.open(url, '_blank')}>
          <Stack spacing={0} w="full">
            {renderDomain(url)}
            <Box pl={6}>
              <Text lineHeight="shorter" noOfLines={2} textOverflow="ellipsis">
                {title}
              </Text>
            </Box>
          </Stack>
        </ReferenceWrapper>
      </CustomTooltip>
    </Box>
  );
};
